import { featuredScenes } from "@/mocks/home";

export default function SceneRecord() {
  const [lead, ...rest] = featuredScenes;

  return (
    <section id="scene" className="border-y border-background-200/60 bg-background-100 py-16 md:py-24">
      <div className="shell">
        <div className="flex flex-col justify-between gap-5 md:flex-row md:items-end">
          <div className="border-l-2 border-primary-500 pl-4 md:pl-5">
            <span className="text-xs font-semibold tracking-[0.2em] text-primary-600">
              ON THE SCENE · 现场直击
            </span>
            <h2 className="mt-2 font-serif text-2xl font-bold text-foreground-950 md:text-3xl">
              图文记录，还原聚集现场
            </h2>
          </div>
          <p className="max-w-sm text-sm leading-relaxed text-foreground-600">
            每一格画面都来自一线，记录人群怎么聚起来、现场如何沸腾，又在哪里散场。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 md:mt-14 lg:grid-cols-3">
          <a
            href="#top"
            className="group cursor-pointer overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-200 lg:col-span-2 lg:row-span-2"
          >
            <div className="relative h-56 w-full overflow-hidden md:h-80 lg:h-[420px]">
              <img
                src={lead.cover}
                alt={lead.title}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.03]"
              />
              <span className="absolute left-4 top-4 rounded-md bg-primary-500 px-2.5 py-1 text-xs font-medium text-background-50">
                今日头条围观
              </span>
              <span className="absolute bottom-4 right-4 flex items-center gap-1 rounded-full bg-background-950/60 px-2.5 py-1 text-[11px] text-background-50 backdrop-blur-sm">
                <i className="ri-eye-line"></i>
                {lead.watchers.toLocaleString()} 人在围观
              </span>
            </div>
            <div className="flex flex-col gap-3 p-5 md:p-6">
              <div className="flex flex-wrap items-center gap-2">
                <span className="flex items-center gap-1 whitespace-nowrap text-xs text-secondary-700">
                  <i className="ri-map-pin-line"></i>
                  {lead.place}
                </span>
                <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] text-secondary-800">
                  {lead.tag}
                </span>
              </div>
              <h3 className="font-serif text-lg font-bold text-foreground-950 transition-colors group-hover:text-primary-700 md:text-xl">
                {lead.title}
              </h3>
              <p className="text-sm leading-relaxed text-foreground-600">{lead.desc}</p>
              <span className="flex items-center gap-1.5 text-xs text-foreground-500">
                <i className="ri-time-line"></i>
                {lead.time}
              </span>
            </div>
          </a>

          {rest.map((s) => (
            <a
              key={s.id}
              href="#top"
              className="group flex cursor-pointer overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-200"
            >
              <div className="relative w-2/5 shrink-0 overflow-hidden">
                <img
                  src={s.cover}
                  alt={s.title}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
                />
              </div>
              <div className="flex w-3/5 flex-col justify-between gap-2 p-4">
                <div>
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="whitespace-nowrap text-[11px] text-secondary-700">{s.tag}</span>
                    <span className="flex items-center gap-0.5 whitespace-nowrap text-[11px] text-accent-600">
                      <i className="ri-eye-line"></i>
                      {(s.watchers / 1000).toFixed(1)}k
                    </span>
                  </div>
                  <h3 className="mt-1.5 text-sm font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
                    {s.title}
                  </h3>
                  <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-foreground-600">
                    {s.desc}
                  </p>
                </div>
                <span className="flex items-center gap-1 text-[11px] text-foreground-400">
                  <i className="ri-map-pin-line"></i>
                  {s.place}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}